import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Unauthorized from "./pages/Unauthorized";

/* ================= HR PAGES ================= */
import HrDashboard from "./pages/hr/Dashboard";
import HrEmployees from "./pages/hr/Employees";
import Onboarding from "./pages/hr/Onboarding";
import HrAttendance from "./pages/hr/Attendance";
import HrPayroll from "./pages/hr/Payroll";
import HrLeaves from "./pages/hr/Leaves";
import HrReports from "./pages/hr/Reports";
import EditEmployee from "./pages/hr/EditEmployee";
import ViewEmployee from "./pages/hr/ViewEmployee";
import Recruitment from "./pages/hr/Recruitment";
import Documents from "./pages/hr/Documents";
import Notifications from "./pages/hr/Notifications";
import HRCalendar from "./pages/hr/HRCalendar";
import Settings from "./pages/hr/Settings";

/* ================= MANAGER PAGES ================= */
import ManagerDashboard from "./pages/manager/Dashboard";
import ManagerTeam from "./pages/manager/Team";
import ManagerAttendance from "./pages/manager/Attendance";
import ManagerAnnouncements from "./pages/manager/Announcements";
import ManagerLeaveRequests from "./pages/manager/LeaveRequests";
import ManagerTimesheetApprovals from "./pages/manager/TimesheetApprovals";

/* ================= EMPLOYEE PAGES ================= */
import EmployeeDashboard from "./pages/employee/Dashboard";
import EmployeeProfile from "./pages/employee/Profile";
import EmployeeApplyLeave from "./pages/employee/ApplyLeave";
import EmployeeAttendance from "./pages/employee/Attendance";
import EmployeePayslips from "./pages/employee/Payslips";
import EmployeeDocuments from "./pages/employee/Documents";
import EmployeeNotifications from "./pages/employee/Notifications";
import EmployeeHRCalendar from "./pages/employee/HRCalendar";
import EmployeeOnboarding from "./pages/employee/EmployeeOnboarding";

/* ========= Redirect user after login ========= */
const RedirectToDashboard = () => {
  const role = localStorage.getItem("role");
  if (!role) return <Navigate to="/login" replace />;
  if (role === "hr") return <Navigate to="/hr/dashboard" replace />;
  if (role === "manager") return <Navigate to="/manager/dashboard" replace />;
  return <Navigate to="/employee/dashboard" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/" element={<RedirectToDashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* ================= HR ROUTES ================= */}
        <Route
          path="/hr/dashboard"
          element={<ProtectedRoute allowed={["hr"]}><Layout><HrDashboard /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/employees"
          element={<ProtectedRoute allowed={["hr"]}><Layout><HrEmployees /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/employees/edit/:id"
          element={<ProtectedRoute allowed={["hr"]}><Layout><EditEmployee /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/employees/view/:id"
          element={<ProtectedRoute allowed={["hr"]}><Layout><ViewEmployee /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/attendance"
          element={<ProtectedRoute allowed={["hr"]}><Layout><HrAttendance /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/payroll"
          element={<ProtectedRoute allowed={["hr"]}><Layout><HrPayroll /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/leaves"
          element={<ProtectedRoute allowed={["hr"]}><Layout><HrLeaves /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/reports"
          element={<ProtectedRoute allowed={["hr"]}><Layout><HrReports /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/onboarding"
          element={<ProtectedRoute allowed={["hr"]}><Layout><Onboarding /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/recruitment"
          element={<ProtectedRoute allowed={["hr"]}><Layout><Recruitment /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/documents"
          element={<ProtectedRoute allowed={["hr"]}><Layout><Documents /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/notifications"
          element={<ProtectedRoute allowed={["hr"]}><Layout><Notifications /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/calendar"
          element={<ProtectedRoute allowed={["hr"]}><Layout><HRCalendar /></Layout></ProtectedRoute>}
        />
        <Route
          path="/hr/settings"
          element={<ProtectedRoute allowed={["hr"]}><Layout><Settings /></Layout></ProtectedRoute>}
        />

        {/* ================= MANAGER ROUTES ================= */}
        <Route
          path="/manager/dashboard"
          element={<ProtectedRoute allowed={["manager"]}><Layout><ManagerDashboard /></Layout></ProtectedRoute>}
        />
        <Route
          path="/manager/team"
          element={<ProtectedRoute allowed={["manager"]}><Layout><ManagerTeam /></Layout></ProtectedRoute>}
        />
        <Route
          path="/manager/attendance"
          element={<ProtectedRoute allowed={["manager"]}><Layout><ManagerAttendance /></Layout></ProtectedRoute>}
        />
        <Route
          path="/manager/announcements"
          element={<ProtectedRoute allowed={["manager"]}><Layout><ManagerAnnouncements /></Layout></ProtectedRoute>}
        />
        <Route
          path="/manager/leaverequests"
          element={<ProtectedRoute allowed={["manager"]}><Layout><ManagerLeaveRequests /></Layout></ProtectedRoute>}
        />
        <Route
          path="/manager/timesheetapprovals"
          element={<ProtectedRoute allowed={["manager"]}><Layout><ManagerTimesheetApprovals /></Layout></ProtectedRoute>}
        />

        {/* ================= EMPLOYEE ROUTES ================= */}
        <Route
          path="/employee/dashboard"
          element={<ProtectedRoute allowed={["employee"]}><Layout><EmployeeDashboard /></Layout></ProtectedRoute>}
        />
        <Route
          path="/employee/profile"
          element={<ProtectedRoute allowed={["employee"]}><Layout><EmployeeProfile /></Layout></ProtectedRoute>}
        />
        <Route
          path="/employee/apply-leave"
          element={<ProtectedRoute allowed={["employee"]}><Layout><EmployeeApplyLeave /></Layout></ProtectedRoute>}
        />
        <Route
          path="/employee/attendance"
          element={<ProtectedRoute allowed={["employee"]}><Layout><EmployeeAttendance /></Layout></ProtectedRoute>}
        />
        <Route
          path="/employee/payroll"
          element={<ProtectedRoute allowed={["employee"]}><Layout><EmployeePayslips /></Layout></ProtectedRoute>}
        />
        <Route
          path="/employee/documents"
          element={<ProtectedRoute allowed={["employee"]}><Layout><EmployeeDocuments /></Layout></ProtectedRoute>}
        />
        <Route
          path="/employee/notifications"
          element={<ProtectedRoute allowed={["employee"]}><Layout><EmployeeNotifications /></Layout></ProtectedRoute>}
        />
        <Route
          path="/employee/calendar"
          element={<ProtectedRoute allowed={["employee"]}><Layout><EmployeeHRCalendar /></Layout></ProtectedRoute>}
        />
        <Route
          path="/employee/onboarding"
          element={<ProtectedRoute allowed={["employee"]}><Layout><EmployeeOnboarding /></Layout></ProtectedRoute>}
        />

        {/* Fallback */}
        <Route path="*" element={<div className="p-6 text-red-500">Page Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
